import { render, staticRenderFns } from "./CrmMenu.vue?vue&type=template&id=6cb5f8a5&scoped=true"
import script from "./CrmMenu.vue?vue&type=script&lang=ts"
export * from "./CrmMenu.vue?vue&type=script&lang=ts"
import style0 from "./CrmMenu.vue?vue&type=style&index=0&id=6cb5f8a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb5f8a5",
  null
  
)

export default component.exports